import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  mapContainer: {
    '& > div': {
      position: 'relative!important',
    },
  },
}));
